import { transformStringTo24HrTime } from './StringTimeTransformer';

/**
 * @param {typeof googleBusinessDataPropType} googleBusinessData
 */
const transformGBPWhatsNew = (googleBusinessData) => {
  if (googleBusinessData.cta === 'none' || !googleBusinessData.cta) {
    googleBusinessData.link = null;
  }

  googleBusinessData.title = null;
  googleBusinessData.start_date = null;
  googleBusinessData.end_date = null;
  googleBusinessData.start_time = null;
  googleBusinessData.end_time = null;
  googleBusinessData.code = null;
  googleBusinessData.terms = null;

  return googleBusinessData;
};

/**
 * @param {typeof googleBusinessDataPropType} googleBusinessData
 */
const transformGBPEvent = (googleBusinessData) => {
  if (googleBusinessData.cta === 'none' || !googleBusinessData.cta) {
    googleBusinessData.link = null;
  }

  googleBusinessData.code = null;
  googleBusinessData.terms = null;

  return googleBusinessData;
};

/**
 * @param {typeof googleBusinessDataPropType} googleBusinessData
 */
const transformGBPOffer = (googleBusinessData) => {
  googleBusinessData.cta = null;

  return googleBusinessData;
};

/**
 *
 * @param updateType
 * @param googleBusinessData
 * @returns {{[p: string]: any}}
 */
const transformGoogleBusinessData = (updateType, googleBusinessData) => {
  let transformedData;
  if (updateType === 'whats_new') {
    transformedData = transformGBPWhatsNew(googleBusinessData);
  }

  if (updateType === 'offer') {
    transformedData = transformGBPOffer(googleBusinessData);
  }

  if (updateType === 'event') {
    transformedData = transformGBPEvent(googleBusinessData);
  }

  // remove empty keys
  transformedData = Object.fromEntries(
    Object.entries(transformedData).filter(
      ([, v]) => v !== null && v !== '' && v !== undefined
    )
  );

  if (transformedData.start_time) {
    const transformedStartTime = transformStringTo24HrTime(
      transformedData.start_time
    );
    const transformedEndTime = transformStringTo24HrTime(
      transformedData.end_time
    );
    transformedData.start_time = `${transformedStartTime.hours}:${transformedStartTime.minutes}`;
    transformedData.end_time = `${transformedEndTime.hours}:${transformedEndTime.minutes}`;
  }

  return transformedData;
};

/**
 *
 * @param {typeof channelDataPropType} channelData
 */
const transformChannelData = (channelData, updateType) => {
  if (!channelData) {
    return null;
  }

  const transformedChannelData = {};

  if (channelData.googlebusiness) {
    transformedChannelData.googlebusiness = transformGoogleBusinessData(
      updateType,
      channelData.googlebusiness
    );
  }

  if (channelData.instagram) {
    transformedChannelData.instagram = channelData.instagram;
  }

  if (channelData.startPage) {
    transformedChannelData.startPage = channelData.startPage;
  }

  if (channelData.youtube) {
    transformedChannelData.youtube = channelData.youtube;
  }

  return transformedChannelData;
};

export default transformChannelData;
